"use client";
import { forwardRef, useState } from "react";
import Icon from "./Icon";

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onSearch?: (value: string) => void;
  onReset?: (event: React.FormEvent<HTMLInputElement>) => void;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ placeholder, onSearch = null, defaultValue, onReset, ...rest }, ref) => {
    const [query, setQuery] = useState<string>((defaultValue as string) ?? "");

    return (
      <div className="form-field-input-wrapper position-relative search-bar">
        <input
          ref={ref}
          type="search"
          placeholder={placeholder}
          {...rest}
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            rest?.onChange?.(e);
          }}
          className="form-field-input search-field"
        />
        {query && (
          <button
            className="position-absolute end-0 d-flex translate-middle-y cursor-pointer color-bg-surface-input"
            onClick={(e) => {
              setQuery("");
              if (onReset) {
                const fakeEvent = {
                  ...e,
                  currentTarget: document.createElement("input"),
                  target: document.createElement("input"),
                } as unknown as React.FormEvent<HTMLInputElement>;

                onReset(fakeEvent);
              }
            }}
            style={{
              marginRight: "2.25rem",
              top: "21px",
            }}
          >
            <Icon icon="close" />
          </button>
        )}
        {onSearch && (
          <button
            className="position-absolute end-0 d-flex translate-middle-y cursor-pointer color-bg-surface-input"
            onClick={() => onSearch(query)}
            style={{
              marginRight: "0.5rem",
              top: "21px",
            }}
          >
            <Icon icon="search" />
          </button>
        )}
      </div>
    );
  },
);

SearchInput.displayName = "SearchInput";
export default SearchInput;
